import { AnyAction, ThunkDispatch } from 'store/store';
import State from 'store/State';
import Services from 'store/Services';
import { PortfolioPosition } from 'portfolio/PortfolioSelection';

export const bufferedPositionEntrySetAction =
    (position: PortfolioPosition) =>
    async (
        _dispatch: ThunkDispatch<AnyAction>,
        _getState: () => State,
        { positionEntryBufferService }: Services
    ) => {
        positionEntryBufferService.setPosition(position);
    };

export const bufferedPositionEntryClearAction =
    (clearInput?: boolean) =>
    async (
        _dispatch: ThunkDispatch<AnyAction>,
        _getState: () => State,
        { positionEntryBufferService }: Services
    ) => {
        positionEntryBufferService.clearPosition(clearInput);
    };
